import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedataService {
  private urlNav = new Subject<any>();
  $dataUrl = this.urlNav.asObservable();

  constructor(private ngZone: NgZone) { }

  doShareNaveName(data: string){
   return this.ngZone.run(() => {
      this.urlNav.next(data)
    })
  }
}
